import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import messages from './messages';
import styles from './styles.module.scss';
import logo from '../../assets/images/logo.svg';

export function NotFound() {
  const { formatMessage } = useIntl();

  return (
    <div>
      <Helmet>
        <title>Maintenance Mode</title>
      </Helmet>
      <main className={styles.container}>
        <div>
          <div className={styles.header}>
            <img src={logo} alt="logo" />
            <h1>{formatMessage(messages.header)}</h1>
          </div>
          <h4>{formatMessage(messages.description)}</h4>
        </div>
      </main>
    </div>
  );
}

export default NotFound;
